import styles from '../DataTable.module.css';

/**
 * Loading — skeleton rows at the REAL row height, inside the real table.
 *
 * Handoff: "skeleton rows at the real row height, 12px bars, radius 3px,
 * shimmer ... No centred spinner over a table."
 *
 * A spinner over a table tells an agent that something is happening and nothing
 * about what is arriving. Skeleton rows at `var(--row-h)` tell them how many
 * rows and how many columns, and — because they are real `<tr>`s in the real
 * `<tbody>` — the table does not resize when the data lands, which is what
 * makes the page stop jumping.
 *
 * This is why the skeleton reads DataTable.module.css rather than a sheet of
 * its own: its rows ARE table rows and must take the same height, hairline and
 * cell padding as the rows they are standing in for. A second stylesheet is a
 * second place for the row height to be wrong.
 *
 * `aria-busy` is on the tbody, per the handoff's "Skeletons and spinners set
 * aria-busy". The bars themselves are `aria-hidden`: they carry no information,
 * and eight rows of unnamed boxes is worse than silence. What a screen reader
 * hears is DataTable's live region saying "Loading".
 */

export function LoadingSkeleton({ columns, rows }: { columns: number; rows: number }) {
  return (
    <tbody className={styles['body']} data-testid="skeleton" aria-busy="true">
      {Array.from({ length: rows }, (_, row) => (
        <tr key={row} className={styles['row']}>
          {Array.from({ length: columns }, (_, column) => (
            <td key={column} className={styles['cell']}>
              <span className={styles['skeletonBar']} aria-hidden="true" data-testid="skeletonBar" />
            </td>
          ))}
        </tr>
      ))}
    </tbody>
  );
}
